import { useState } from "react";
import "./KbAdd.css";

function KbAdd() {
  const [openActionRow, setOpenActionRow] = useState(null);
const[showModal,setShowModal]=useState(false)

const [showPassword, setShowPassword] = useState(false);
const [showpop, setShowPop] = useState(false);
  const handleEdit = (item) => {
    console.log("Edit:", item);
  };

  const handleDelete = (id) => {
    console.log("Delete:", id);
  };

  const integrationsData = [
    {
      id: 1,
      integration: "SharePoint",
      category: "Document Store",
      status: "Connected",
      usedBy: "HR, IT",
      lastSync: "2 hours ago"
    },
    {
      id: 2,
      integration: "Gmail",
      category: "Email",
      status: "Paused",
      usedBy: "Finance",
      lastSync: "1 day ago"
    }
  ];

  return (
    <div className="container-fluid my-3 px-0">

      {/* Top Bar */}
      <div className="mx-4 p-4 bg-white shadow-sm rounded-2">

        <div className="row align-items-center gx-3">

          <div className="col-md-4 col-8">

            <div className="position-relative">

              <i
                className="bi bi-search position-absolute text-muted"
                style={{
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)"
                }}
              ></i>

              <input
                type="text"
                className="form-control ps-5 shadow-sm"
                placeholder="Search Sources..."
              />

            </div>

          </div>

          <div className="col-1 ms-auto me-3 text-end">

            <button className="btn btn-primary" onClick={()=>setShowPop(true)}>
              + New
            </button>

          </div>

        </div>

      </div>


      {/* Table */}
      <div className="p-4">

        <div className="table-responsivess table-wrapper">

          <table className="table  table-bordered align-middle mb-0 ">

            <thead className="table-light text-center">
              <tr>

                <th>
                  <input
                    type="checkbox"
                    className="form-check-input"
                  />
                </th>

                <th>Integration</th>
                <th>Category</th>
                <th>Status</th>
                <th>Used By</th>
                <th>Last Sync</th>
                <th>Action</th>

              </tr>
            </thead>

            <tbody>

              {integrationsData.map((item) => (
                <tr key={item.id} className="text-center">

                  <td>
                    <input
                      type="checkbox"
                      className="form-check-input"
                    />
                  </td>

                  <td className="fs-6">
                    {item.integration}
                  </td>

                  <td>{item.category}</td>

                  <td>
                    <span
                      className={`fs-6 ${
                        item.status === "Connected"
                          ? "text-success"
                          : "text-danger"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>

                  <td>{item.usedBy}</td>

                  <td>{item.lastSync}</td>

                  <td className="position-relative">

                    <button
                      className="btn btn-sm btn-light"
                      onClick={() =>
                        setOpenActionRow(
                          openActionRow === item.id ? null : item.id
                        )
                      }
                    >
                      <i className="bi bi-three-dots-vertical"></i>
                    </button>

                    {openActionRow === item.id && (
                      <div className="action-menu">

                        <div
                          className="action-menu-item"
                          onClick={() => {
                            handleEdit(item);
                            setOpenActionRow(null);
                          }}
                        >
                          Edit
                        </div>

                        <div
                          className="action-menu-item text-danger"
                          onClick={() => {
                            handleDelete(item.id);
                            setOpenActionRow(null);
                          }}
                        >
                          Delete
                        </div>

                      </div>
                    )}

                  </td>

                </tr>
              ))}

            </tbody>

          </table>

        </div>

      </div>
   {/* {showModal && (
  <div
    className="kb-modal-overlay"
    onClick={() => setShowModal(false)}
  >
    <div
      className="kb-modal"
      onClick={(e) => e.stopPropagation()}
    >

   
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-0 fw-semibold">
          Connect Source
        </h6>

        <button
          className="btn-close"
          onClick={() => setShowModal(false)}
        ></button>
      </div>

      <hr />

    
      <div className="mb-3">
        <label className="form-label fw-semibold small">
          Source
        </label>

        <select className="form-select">
          <option value="">Select Source</option>
          <option value="sharepoint">SharePoint</option>
          <option value="gmail">Gmail</option>
          <option value="drive">Google Drive</option>
          <option value="slack">Slack</option>
        </select>
      </div>

   
      <div className="mb-3">
        <label className="form-label fw-semibold small">
          URL
        </label>

        <select className="form-select">
          <option value="">Select URL</option>
          <option value="https://example1.com">
            https://example1.com
          </option>
          <option value="https://example2.com">
            https://example2.com
          </option>
        </select>
      </div>


      <div className="d-flex justify-content-end gap-2 mt-3">

        <button
          className="btn btn-outline-secondary"
          onClick={() => setShowModal(false)}
        >
          Cancel
        </button>

        <button className="btn btn-primary">
       Save
        </button>

      </div>

    </div>
  </div>
)} */}
{showpop && (
  <div
    className="kb-modal-overlay "
    onClick={() => setShowPop(false)}
  >
    <div
      className="kb-modal w-25"
      onClick={(e) => e.stopPropagation()}
    >

      {/* Header */}
      <div className="d-flex justify-content-between align-items-center border-bottom  mb-2">

        <h6 className="mb-0 fw-semibold">
          Connect Source
        </h6>

        <button
          className="btn-close"
          onClick={() => setShowPop(false)}
        ></button>

      </div>


<form>

  <div className="col-lg-12">

    {/* Source */}
    <div className="col-12 mb-3">
      <label className="form-label small  text-color-drop" >
        Source
      </label>

      <select className="form-select " style={{marginTop:'-6px'}}>
        <option value="">Select Source</option>
        <option>PostgreSQL</option>
        <option>MySQL</option>
        <option>MongoDB</option>
      </select>
    </div>


    {/* Type */}
    <div className="col-12 mb-3">
      <label className="form-label small  text-color-drop">
        Type
      </label>

      <select className="form-select "  style={{marginTop:'-6px'}}>
        <option value="">Select Type</option>
        <option>Cloud</option>
        <option>Local</option>
      </select>
    </div>


    {/* Host */}
    <div className="col-12 mb-3"  style={{marginTop:'-6px'}}>
      <label className="form-label small text-color-drop">
        Host
      </label>

      <input
        type="text"
        className="form-control"
        placeholder="localhost"
         style={{marginTop:'-6px'}}
      />
    </div>


    {/* Port */}
    <div className="col-12 mb-3"  style={{marginTop:'-6px'}}>
      <label className="form-label small  text-color-drop">
        Port
      </label>

      <input
        type="number"
        className="form-control"
        placeholder="Number"
         style={{marginTop:'-6px'}}
      />
    </div>


    {/* Username */}
    <div className="col-12 mb-3">
      <label className="form-label small  text-color-drop">
        Username
      </label>

      <input
        type="text"
        className="form-control"
        placeholder="postgres"
         style={{marginTop:'-6px'}}
      />
    </div>


    {/* Password */}
 <div className="col-12 mb-3">
  <label className="form-label small  text-color-drop">
    Password
  </label>

  <div className="position-relative">

    <input
      type={showPassword ? "text" : "password"}
      className="form-control pe-5"
      placeholder="PassWord"
      style={{ marginTop: "-6px" }}
    />

    <i
      className={`bi ${
        showPassword ? "bi-eye-slash" : "bi-eye"
      } position-absolute top-50 end-0 translate-middle-y me-3`}
      style={{ cursor: "pointer" }}
      onClick={() => setShowPassword(!showPassword)}
    ></i>

  </div>
</div>


    {/* Database */}
    <div className="col-12 mb-3">
      <label className="form-label small  text-color-drop">
        Database Name
      </label>

      <input
        type="text"
        className="form-control"
        placeholder="my_database"
         style={{marginTop:'-6px'}}
      />
    </div>

  </div>


  {/* Footer */}
  <div className="d-flex justify-content-end gap-2  pt-2 border-top">

    <button
      type="button"
      className="btn btn-outline-secondary"
      onClick={() => setShowPop(false)}
    >
      Cancel
    </button>

    <button
      type="submit"
      className="btn btn-primary">
      Save
    </button>

  </div>

</form>

    </div>
  </div>
)}

    </div>
  );
}

export default KbAdd;